(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instructor-tabs"] && !Shopify.designMode) return;
  try {
    
class InstructorTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.panelsContainer = this.querySelector('.tab-panels');
    this.activeTabIndex = this.tabButtons.findIndex((tab) => tab.classList.contains('is-active'));
    if (this.activeTabIndex === -1) {
      this.activeTabIndex = 0;
    }
    this.handleClick = (event) => {
      const button = event.currentTarget;
      this.setActiveTab(button);
    };
  }

  connectedCallback() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.handleClick);
    });
  }

  disconnectedCallback() {
    this.tabButtons.forEach((button) => {
      button.removeEventListener('click', this.handleClick);
    });

  }

  setActiveTab(button) {
    if (!button) return;

    const targetId = button.dataset.tabTarget;
    const targetPanel = this.querySelector(`#${targetId}`);

    if (!targetPanel) return;

    this.tabButtons.forEach((tab) => {
      const controls = tab.getAttribute('aria-controls');
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      const panel = this.querySelector(`#${controls}`);
      if (panel) {
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    });

    this.activeTabIndex = this.tabButtons.indexOf(button);
  }
}

if (!customElements.get('instructor-tabs')) {
  customElements.define('instructor-tabs', InstructorTabs);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oa-7-days-landing"] && !Shopify.designMode) return;
  try {
    
/* Click-to-load YouTube/Vimeo player. The iframe (and its third-party
   scripts) is only requested after the visitor presses play. Defined once;
   custom elements also upgrade automatically after theme-editor re-renders. */
if (!customElements.get('oa-7-days-landing-video')) {
  customElements.define('oa-7-days-landing-video', class extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('.oa-7-days-landing__video-trigger');
      if (!trigger || this.dataset.bound) return;
      this.dataset.bound = 'true';
      const warm = () => this.preconnect();
      trigger.addEventListener('pointerenter', warm, { once: true });
      trigger.addEventListener('focus', warm, { once: true });
      trigger.addEventListener('click', () => this.play(trigger), { once: true });
    }

    preconnect() {
      try {
        const origin = new URL(this.dataset.src).origin;
        if (document.head.querySelector(`link[rel="preconnect"][href="${origin}"]`)) return;
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        document.head.append(link);
      } catch (error) {
        /* Invalid URL: nothing to warm up. */
      }
    }

    play(trigger) {
      const iframe = document.createElement('iframe');
      iframe.src = this.dataset.src;
      iframe.title = this.dataset.title || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.className = 'oa-7-days-landing__media-fill';
      trigger.replaceWith(iframe);
      iframe.focus();
    }
  });
}

/* Swipeable day row: becomes a focusable, labelled scroll region only while
   it actually scrolls (mobile swipe layout), so keyboard users can scroll it
   with arrow keys and desktop users get no empty tab stop. */
if (!customElements.get('oa-7-days-landing-swipe')) {
  customElements.define('oa-7-days-landing-swipe', class extends HTMLElement {
    connectedCallback() {
      this.query = window.matchMedia('(max-width: 749px)');
      this.onChange = () => this.update();
      this.query.addEventListener('change', this.onChange);
      this.update();
    }

    disconnectedCallback() {
      if (this.query) this.query.removeEventListener('change', this.onChange);
    }

    update() {
      const active = this.query.matches && Boolean(this.closest('.oa-7-days-landing__days--swipe'));
      if (active) {
        this.setAttribute('tabindex', '0');
        this.setAttribute('role', 'region');
        this.setAttribute('aria-label', this.dataset.label || '');
      } else {
        this.removeAttribute('tabindex');
        this.removeAttribute('role');
        this.removeAttribute('aria-label');
      }
    }
  });
}

/* Sticky call to action: shown once the visitor scrolls past the first
   screen, hidden while any element marked data-sticky-hide (hero, final CTA)
   is visible. Hidden state is inert so it never traps keyboard focus. */
if (!customElements.get('oa-7-days-landing-sticky')) {
  customElements.define('oa-7-days-landing-sticky', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.oa-7-days-landing') || document;
      this.onScreen = new Set();
      this.forced = false;
      this.bar = this.querySelector('.oa-7-days-landing__sticky-bar');

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.onScreen.add(entry.target);
          else this.onScreen.delete(entry.target);
        });
        this.update();
      });
      this.root.querySelectorAll('[data-sticky-hide]').forEach((el) => this.observer.observe(el));

      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });

      this.onSelect = (event) => {
        if (event.detail && event.detail.blockId === this.dataset.blockId) {
          this.forced = event.type === 'shopify:block:select';
          this.update();
        }
      };
      document.addEventListener('shopify:block:select', this.onSelect);
      document.addEventListener('shopify:block:deselect', this.onSelect);
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('shopify:block:select', this.onSelect);
      document.removeEventListener('shopify:block:deselect', this.onSelect);
    }

    update() {
      const scrolled = window.scrollY > window.innerHeight * 0.6;
      const show = this.forced || (scrolled && this.onScreen.size === 0);
      this.toggleAttribute('data-visible', show);
      if (this.bar) this.bar.inert = !show;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oa-7-days-thank-you"] && !Shopify.designMode) return;
  try {
    
/* Share widget: copies the course link to the clipboard and, on devices that
   support it, opens the native share sheet. Status is announced politely. */
if (!customElements.get('oa-7-days-thank-you-share')) {
  customElements.define('oa-7-days-thank-you-share', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound) return;
      this.dataset.bound = 'true';
      this.url = this.dataset.url || window.location.origin;
      this.copyButton = this.querySelector('[data-share-copy]');
      this.nativeButton = this.querySelector('[data-share-native]');
      this.status = this.querySelector('[data-share-status]');

      if (this.copyButton) this.copyButton.addEventListener('click', () => this.copy());
      if (this.nativeButton && navigator.share) {
        this.nativeButton.hidden = false;
        this.nativeButton.addEventListener('click', () => {
          navigator.share({ title: this.dataset.title || document.title, url: this.url }).catch(() => {});
        });
      }
    }

    async copy() {
      try {
        await navigator.clipboard.writeText(this.url);
        this.announce(this.dataset.copied || 'Link copied');
        this.copyButton.setAttribute('data-copied', '');
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.copyButton.removeAttribute('data-copied'), 2400);
      } catch (error) {
        this.announce(this.url);
      }
    }

    announce(message) {
      if (!this.status) return;
      this.status.textContent = '';
      requestAnimationFrame(() => { this.status.textContent = message; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oa-day-lesson"] && !Shopify.designMode) return;
  try {
    
/* Click-to-load YouTube/Vimeo player. The iframe (and its third-party
   scripts) is only requested after the visitor presses play. Defined once;
   custom elements also upgrade automatically after theme-editor re-renders. */
if (!customElements.get('oa-day-lesson-video')) {
  customElements.define('oa-day-lesson-video', class extends HTMLElement {
    connectedCallback() {
      const trigger = this.querySelector('.oa-day-lesson__video-trigger');
      if (!trigger || this.dataset.bound) return;
      this.dataset.bound = 'true';
      const warm = () => this.preconnect();
      trigger.addEventListener('pointerenter', warm, { once: true });
      trigger.addEventListener('focus', warm, { once: true });
      trigger.addEventListener('click', () => this.play(trigger), { once: true });
    }

    preconnect() {
      try {
        const origin = new URL(this.dataset.src).origin;
        if (document.head.querySelector(`link[rel="preconnect"][href="${origin}"]`)) return;
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = origin;
        document.head.append(link);
      } catch (error) {
        /* Invalid URL: nothing to warm up. */
      }
    }

    play(trigger) {
      const iframe = document.createElement('iframe');
      iframe.src = this.dataset.src;
      iframe.title = this.dataset.title || 'Video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.className = 'oa-day-lesson__media-fill';
      trigger.replaceWith(iframe);
      iframe.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-carousel"] && !Shopify.designMode) return;
  try {
    
class ProductTabsCarousel extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.selectedTitleElement = this.querySelector('[data-active-tab-title]');
    this.viewAllLinkElement = this.querySelector('[data-view-all-link]');
    this.viewAllLinkTextElement = this.querySelector('[data-view-all-link-text]');
    this.viewAllOpenInNewTab = this.viewAllLinkElement
      ? this.viewAllLinkElement.dataset.viewAllOpenNewTab === 'true'
      : false;
    this.activeTabIndex = this.tabButtons.findIndex((tab) => tab.classList.contains('is-active'));
    if (this.activeTabIndex === -1) {
      this.activeTabIndex = 0;
    }
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.tabButtons.forEach((button) => {
      button.addEventListener('click', this.handleClick);
    });
  }

  disconnectedCallback() {
    this.tabButtons.forEach((button) => {
      button.removeEventListener('click', this.handleClick);
    });
  }

  handleClick(event) {
    const button = event.currentTarget;
    this.setActiveTab(button);
  }

  setActiveTab(button) {
    if (!button) return;

    const targetId = button.dataset.tabTarget;
    const targetPanel = this.querySelector(`#${targetId}`);

    if (!targetPanel) return;

    this.tabButtons.forEach((tab) => {
      const controls = tab.getAttribute('aria-controls');
      const isActive = tab === button;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      const panel = this.querySelector(`#${controls}`);
      if (panel) {
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }
    });

    this.activeTabIndex = this.tabButtons.indexOf(button);
    if (this.selectedTitleElement) {
      const buttonLabel = (button.textContent || '').trim();
      if (buttonLabel.length > 0) {
        this.selectedTitleElement.textContent = buttonLabel;
      }
    }
    if (this.viewAllLinkElement) {
      const viewAllLabel = (button.dataset.viewAllLabel || '').trim();
      const viewAllLink = (button.dataset.viewAllLink || '').trim();
      if (viewAllLabel.length === 0) {
        this.viewAllLinkElement.setAttribute('hidden', '');
        this.viewAllLinkElement.setAttribute('aria-hidden', 'true');
        this.viewAllLinkElement.removeAttribute('href');
        this.viewAllLinkElement.setAttribute('role', 'link');
        this.viewAllLinkElement.setAttribute('aria-disabled', 'true');
        this.viewAllLinkElement.removeAttribute('target');
        this.viewAllLinkElement.removeAttribute('rel');
      } else {
        this.viewAllLinkElement.removeAttribute('hidden');
        this.viewAllLinkElement.removeAttribute('aria-hidden');
        if (this.viewAllLinkTextElement) {
          this.viewAllLinkTextElement.textContent = viewAllLabel;
        }
        if (viewAllLink.length > 0) {
          this.viewAllLinkElement.setAttribute('href', viewAllLink);
          this.viewAllLinkElement.removeAttribute('role');
          this.viewAllLinkElement.removeAttribute('aria-disabled');
          if (this.viewAllOpenInNewTab) {
            this.viewAllLinkElement.setAttribute('target', '_blank');
            this.viewAllLinkElement.setAttribute('rel', 'noopener noreferrer');
          } else {
            this.viewAllLinkElement.removeAttribute('target');
            this.viewAllLinkElement.removeAttribute('rel');
          }
        } else {
          this.viewAllLinkElement.removeAttribute('href');
          this.viewAllLinkElement.setAttribute('role', 'link');
          this.viewAllLinkElement.setAttribute('aria-disabled', 'true');
           this.viewAllLinkElement.removeAttribute('target');
           this.viewAllLinkElement.removeAttribute('rel');
        }
      }
    }
  }
}

if (!customElements.get('product-tabs-carousel')) {
  customElements.define('product-tabs-carousel', ProductTabsCarousel);
}

  } catch(e) { console.error(e); }
})();
})();
